import React from 'react';
import { Modal } from 'react-bootstrap';
import AiManagementModalHeader from 'components/molecules/ai_management_modal_header';
import { Container } from './styles';

interface AiManagementArchiveBulkModalProps {
  count: number;
  show: boolean;
  saving: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const AiManagementArchiveBulkModal: React.FC<AiManagementArchiveBulkModalProps> = ({
  count,
  show,
  saving,
  onClose,
  onConfirm,
}) => (
  <Modal show={show} onHide={onClose} centered>
    <Container>
      <AiManagementModalHeader
        title={count === 1 ? 'Arquivar licitação' : 'Arquivar licitações'}
        onClose={onClose}
      />

      <div className="archive-body px-4 pt-4 pb-4">
        <p>
          {count === 1
            ? '1 licitação será arquivada e movida para a página de licitações arquivadas.'
            : `${count} licitações serão arquivadas e movidas para a página de licitações arquivadas.`}
        </p>
        <p>
          <strong>Essa ação não pode ser desfeita,</strong> mas você pode desarquivar os itens a
          qualquer momento.
        </p>
        <p>Deseja continuar?</p>
      </div>

      <div className="d-flex justify-content-end border-top px-4 py-3">
        <button
          type="button"
          className="btn btn-outline-secondary mr-2"
          onClick={onClose}
          disabled={saving}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="btn btn-primary px-4"
          onClick={onConfirm}
          disabled={saving}
        >
          {saving ? 'Arquivando...' : 'Sim'}
        </button>
      </div>
    </Container>
  </Modal>
);

export default AiManagementArchiveBulkModal;
